import React, { useState, useEffect } from "react";
import {
  Button,
  Offcanvas,
  Modal,
  Form,
  Tabs,
  Tab,
  Table,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import {
  WidgetsOutlined,
  AppsOutlined,
  BookmarkBorderOutlined,
  AddOutlined,
  WallpaperOutlined,
  DeleteForeverOutlined,
  ModeEditOutlined,
  VisibilityOutlined,
  DragHandleOutlined,
  ArrowForwardIosOutlined
} from "@mui/icons-material";
import toast from "react-hot-toast";
import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import axios from "axios";
import useHome from "../../hooks/useHome";
import { idGenerator } from "../../helpers/idGenerator";
import usePgiModules from "../../hooks/useModules";
import TinyMCE from "./tinyMCE";
import useAudit from "../../hooks/useAudit";
import { titleRegex } from "../../helpers/constants";

const SideBarProducts = ({ values, isEdit }) => {
  const [showCreateBanner, setShowCreateBanner] = useState(false);
  const handleCloseBanner = () => setShowCreateBanner(false);
  const handleShowBanner = () => setShowCreateBanner(!showCreateBanner);
  const [editProduct, setEditProduct] = useState(values);
  const [modalFor, setModalFor] = useState(null);
  const [modulesNew, setModulesNew] = useState(null);
  const [objectId, setObjectId] = useState(null);
  const [selectBanner, setSelectBanner] = useState(false);
  const [selectBloque, setSelectBloque] = useState(false);
  const { banners, handleVisibilityBanners, handleVisibilityBloque, getBloqueInfo } = useHome();
  const { modules, handleVisibility, handleModuleUpdate } = usePgiModules();
  const { createAuditRequest } = useAudit();
  const [bloques, setBloques] = useState([]);

  const arrayBanner = banners?.find((banner) => banner.state === true);
  // MODAL GALERIA
  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);

  useEffect(() => {
    const getInfoBloque = async () => {
      try {
        const response = await getBloqueInfo();
        setBloques(response.data.allBloqueInfo);
      } catch (error) {
        toast.error('Error al obtener la informacion de los bloques')
      }
    }
    getInfoBloque();
  }, []);

  useEffect(() => {
    setModulesNew(
      modules?.filter(
        (module) =>
          module?.title === "Carrousel_deLinea" ||
          module?.title === "Carrousel_especial" ||
          module?.title === "Banner_publicitario" ||
          module?.title === "Bloque_info"
      )
    );
  }, [modules]);

  const handleDeleteBenefit = (id) => {
    setEditProduct({
      ...editProduct,
      benefit: editProduct?.benefit?.filter((item, i) => item?._id !== id)
    });
  };

  const handleBenefitInput = ({ target }) => {
    setEditProduct({
      ...editProduct,
      benefit: editProduct.benefit?.map((item, i) => {
        if (i === Number(target.id)) {
          return { ...item, [target.name]: target.value };
        }
        return item;
      })
    });
  };

  const handleAddBenefit = () => {
    isEdit
      ? setEditProduct({
          ...editProduct,
          benefit: [
            ...editProduct?.benefit,
            { iconBenefit: "", textBenefit: "", _id: idGenerator(12) }
          ]
        })
      : setEditProduct({
          ...editProduct,
          benefit: [
            ...(editProduct?.benefit ? values?.benefit : ""),
            { iconBenefit: "", textBenefit: "", _id: idGenerator(12) }
          ]
        });
  };

  const handleInputChange = ({ target }) => {
    var galleryEnable = editProduct.galleryEnabled;
    var faqsEnable = editProduct.faqsEnabled;
    var instalacionEnabled = editProduct.instalationStepsEnabled;

    switch (target.name) {
      case "galleryEnabled":
        galleryEnable = target.checked;
        break;
      case "instalacionEnabled":
        instalacionEnabled = target.checked;
        break;
      case "faqsEnabled":
        faqsEnable = target.checked;
        break;
      default:
    }
    // if(target.name === "galleryEnabled"){
    // }
    // else if(target.name === "galleryEnabled"){
    // }
    setEditProduct({
      ...editProduct,
      [target.name]: target.value,
      publish: false,
      galleryEnabled: galleryEnable,
      faqsEnabled: faqsEnable,
      instalationStepsEnabled: instalacionEnabled
    });
  };

  
  const user = JSON.parse(localStorage.getItem('Usuario'))?.UserLogin?.name

  const handleSubmit = async (e) => {
    e.preventDefault();

    const title = editProduct.title.trim();
  
    if (!title || !titleRegex.test(title)) {
      toast.error("Este título contiene caracteres no válidos");
      return;
    }

    /* Beneficios */
    const benefitsFields = Array.from(document.getElementsByClassName("fieldBenefit"));

    let someEmpty = benefitsFields.some((field) => {
      return field.value === "";
    });

    if (benefitsFields.length === 0 || someEmpty) {
      toast.error("No pueden haber campos de Beneficios vacíos");
      return;
    }
    
    if (!editProduct.type.trim()) {
      toast.error("Por favor elige el tipo de producto");
      return;
    }

    try {
      await createAuditRequest(
        { ...editProduct, element: 2, creator: user, publish: true },
        "EDIT"
      );
      // toast.success("Se actualizó producto");
      // setProducts(
      //   products.map((item) => {
      //     if (item._id === editProduct._id) {
      //       return editProduct;
      //     }
      //     return item;
      //   })
      // );
      handleCloseBanner();
    } catch (error) {
      toast.error("Error al actualizar el producto");
    }
  };

  const handleAddStep = () => {
    setEditProduct({
      ...editProduct,
      instalationSteps: [
        ...editProduct.instalationSteps,
        {
          _id: idGenerator(12),
          stepTitle: "",
          stepDescription: "",
          stepWarningText: "",
          imageInstallation: []
        }
      ]
    });
  };

  const handleStepInput = ({ target }) => {
    setEditProduct({
      ...editProduct,
      instalationSteps: editProduct.instalationSteps.map((step, i) => {
        if (step._id === target.id) {
          return { ...step, [target.name]: target.value };
        }
        return step;
      })
    });
  };

  const handleDeleteStep = (index) => {
    setEditProduct({
      ...editProduct,
      instalationSteps: editProduct.instalationSteps.filter((step, i) => i !== index)
    });
  };

  const handleAddFaqs = () => {
    setEditProduct({
      ...editProduct,
      faqs: [
        ...editProduct.faqs,
        { _id: Number(Math.random()), question: "", answer: "", video: "" }
      ]
    });
  };

  const handleFaqsInput = ({ target }) => {
    setEditProduct({
      ...editProduct,
      faqs: editProduct.faqs.map((faq, i) => {
        if (faq._id === Number(target.id)) {
          return { ...faq, [target.name]: target.value };
        }
        return faq;
      })
    });
  };

  const handleDeleteFaqs = (index) => {
    setEditProduct({
      ...editProduct,
      faqs: editProduct.faqs.filter((faq, i) => i !== index)
    });
  };

  const handleFileProduct = async ({ target }) => {
    if (document.querySelector("#ficha-manual").value === "") {
      document.querySelector("#fileProduct").value = "";
      return toast.error("El archivo debe tener un nombre");
    }
    try {
      const form = new FormData();
      form.append("file", target.files[0]);
      form.append("_id", values._id);
      form.append("title", document.querySelector("#ficha-manual").value);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/product/createDoc`,
        form,
        {
          headers: {
            authorization: JSON.parse(localStorage.getItem("Usuario")).token
          }
        }
      );
      setEditProduct({
        ...editProduct,
        filename: [...editProduct.filename, data.data]
      });
      document.querySelector("#ficha-manual").value = "";
      document.querySelector("#fileProduct").value = "";
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
      document.querySelector("#ficha-manual").value = "";
      document.querySelector("#fileProduct").value = "";
    }
  };

  const handleModalClick = (modalFor, objectId) => {
    setModalFor(modalFor);
    setObjectId(objectId);
    handleShowGaleria();
  };

  const handleFileVisibility = (filename) => {
    setEditProduct({
      ...editProduct,
      filename: editProduct.filename.map((f) =>
        f.filename === filename ? { ...f, state: !f.state } : f
      )
    });
  };

  const handleFileDeleted = (filename) => {
    setEditProduct({
      ...editProduct,
      filename: editProduct.filename.map((f) =>
        f.filename === filename ? { ...f, deleted: !f.deleted } : f
      )
    });
  };

  return (
    <div className="pgi__sidebar-slides">
      <OverlayTrigger key="1" placement="top" overlay={<Tooltip id="1">Editar</Tooltip>}>
        <Button
          className="btn-form-pgi"
          variant="light"
          onClick={handleShowBanner}
          setEditProduct={values}
        >
          <ModeEditOutlined />
        </Button>
      </OverlayTrigger>
      {/**INICIO OFF CANVAS */}
      <Offcanvas
        show={showCreateBanner}
        onHide={handleCloseBanner}
        className="basePgi__pgi  pgi__sidebar-container"
        placement="end"
        scroll="true"
        enforceFocus
        backdrop={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            Editar Producto {editProduct.title}
            {/* EN EDITAR el title -->
                Producto / <b>Tensoblock</b> */}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form className="basePgi__vista-edit-gral" id="bloque-txt" onSubmit={handleSubmit}>
            <div>
              <button
                type="submit"
                className="settings_button-pleno float-end mb-3 botton-save-pgi"
              >
                GUARDAR
              </button>
            </div>
            <Tabs
              defaultActiveKey="descripcion"
              active
              id="productos-tab"
              className="pgi__productos-tab"
            >
              <Tab eventKey="descripcion" title="Descripción">
                <form className="basePgi__vista-edit-gral" id="bloque-txt">
                  <fieldset className="pgi__sidebar-container-items form-group">
                    <div className="form-floating pgi__selectProduct">
                      <h3 className="basePgi__comments">Tipo de producto</h3>
                      {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-left" <div className="carousel align-left"></div> */}
                      <Form.Check
                        inline
                        label="Producto Especial"
                        name="type"
                        type="radio"
                        id="productoEspecial"
                        value="productoEspecial"
                        checked={editProduct.type === "productoEspecial"}
                        onChange={handleInputChange}
                      />
                      {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-center" <div className="carousel align-center"></div> */}
                      <Form.Check
                        inline
                        label="Producto de Línea"
                        name="type"
                        type="radio"
                        id="productoLinea"
                        value="productoLinea"
                        checked={editProduct.type === "productoLinea"}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        id="title"
                        placeholder="..."
                        defaultValue={editProduct.title}
                        onChange={handleInputChange}
                        maxLength={30}
                        minLength={2}
                        required
                      />
                      <label htmlFor="title">Nombre del producto </label>
                      <p className="basePgi__comments">
                        <span>No se admiten los siguentes caracteres: "" ( )  * - / </span>
                      </p>
                    </div>
                    <div className="form-floating">
                      <textarea
                        required
                        type="text-area"
                        className="form-control"
                        name="top"
                        id="top"
                        rows="4"
                        for="bloque-txt"
                        defaultValue={editProduct.top}
                        onChange={handleInputChange}
                        placeholder="hola"
                        maxLength={280}
                        minLength={2}
                      />
                      <label htmlFor="top">Descripción</label>
                      <p className="basePgi__comments">
                        <span>Máximo de caracteres: 280.</span>
                      </p>
                    </div>
                    <div className="form-floating">
                      <textarea
                        required
                        type="text-area"
                        className="form-control"
                        name="top_mobile"
                        id="top_mobile"
                        rows="4"
                        for="bloque-txt"
                        defaultValue={editProduct.top_mobile}
                        onChange={handleInputChange}
                        placeholder="hola"
                        maxLength={144}
                        minLength={2}
                      />
                      <label htmlFor="top">Descripción para dispositivos móviles</label>
                      <p className="basePgi__comments">
                        <span>Máximo de caracteres: 144.</span>
                      </p>
                    </div>
                    <article className="d-flex">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm"
                        onClick={() => handleModalClick("fondo")}
                      >
                        Fondo desktop
                        <WallpaperOutlined />
                      </Button>
                      <p className="my-auto w-50">
                        {editProduct.imageBackground.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct.imageBackground.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>
                    </article>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Escritorio (.jpg, .png). Proporción 16:9. Ancho máximo 2048px
                      </span>
                    </p>
                    <article className="d-flex">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm"
                        onClick={() => handleModalClick("fondo_tablet")}
                      >
                        Fondo tablet
                        <WallpaperOutlined />
                      </Button>
                      <p className="my-auto w-50">
                        {editProduct.imageBackground_tablet.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct.imageBackground_tablet.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>
                    </article>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Tablet (.webP, .jpg, .png). Proporción 4:3. Ancho máximo 2048px
                      </span>
                    </p>
                    <article className="d-flex">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm"
                        onClick={() => handleModalClick("fondo_mobile")}
                      >
                        Fondo mobile
                        <WallpaperOutlined />
                      </Button>
                      <p className="my-auto w-50">
                        {editProduct.imageBackground_mobile.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct.imageBackground_mobile.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>
                    </article>
                    <p className="basePgi__comments">
                      <span>
                        Imagen Mobile (.webP, .jpg, .png). Proporción 9:16. Ancho máximo 1200px
                      </span>
                    </p>
                    <div className="form-floating mt-3">
                      <input
                        type="text"
                        className="form-control"
                        name="altImageBackground"
                        id="altImageBackground"
                        placeholder="..."
                        defaultValue={editProduct.altImageBackground}
                        onChange={handleInputChange}
                        maxLength={90}
                      />
                      <label htmlFor="altImageBackground">
                        Ingrese un ALT para la imagen principal{" "}
                      </label>
                    </div>
                    <hr className="basePgi__space-line" />
                    <div className="pgi__sidebar-container-items">
                      <h3>Ítems destacados</h3>
                      <p className="basePgi__comments">
                        Desde aquí podrá cargar cada beneficio de producto y su ícono personalizado.
                      </p>
                      <div className="pgi__archivo pgi__install">
                        {editProduct?.benefit?.map((item, i) => {
                          return (
                            <div className="mx-3" key={item?._id}>
                              <label htmlFor="title">{i + 1}</label>
                              <OverlayTrigger
                                key="1"
                                placement="top"
                                overlay={<Tooltip id="1">Eliminar</Tooltip>}
                              >
                                <Button onClick={() => handleDeleteBenefit(item?._id)}>
                                  <DeleteForeverOutlined />
                                </Button>
                              </OverlayTrigger>
                              <div key={item?._id}>
                                <div className="input-group my-4">
                                  <small className="d-block w-100">Ícono de beneficio</small>
                                  <input
                                    type="text"
                                    className="form-control fieldBenefit"
                                    name="iconBenefit"
                                    placeholder="Ícono"
                                    id={i}
                                    defaultValue={item?.iconBenefit}
                                    onChange={handleBenefitInput}
                                    maxLength={90}
                                    minLength={2}
                                    required
                                  />
                                  <small className="d-block w-100 mt-3">Texto del beneficio</small>
                                  <input
                                    type="text"
                                    className="form-control fieldBenefit"
                                    name="textBenefit"
                                    placeholder="Texto"
                                    id={i}
                                    defaultValue={item?.textBenefit}
                                    onChange={handleBenefitInput}
                                    maxLength={90}
                                    minLength={2}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <OverlayTrigger
                        key="1"
                        placement="top"
                        overlay={<Tooltip id="1">Nuevo Link</Tooltip>}
                      >
                        <Button
                          variant="light"
                          className="btn-form-pgi allW"
                          onClick={handleAddBenefit}
                        >
                          <AddOutlined />
                        </Button>
                      </OverlayTrigger>
                    </div>
                  </fieldset>
                  <hr className="basePgi__space-line" />
                  <fieldset className="pgi__sidebar-container-items form-group">
                    <h3>Contenido</h3>
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        name="titleSubDescription"
                        id="titleSubDescription"
                        defaultValue={editProduct.titleSubDescription}
                        onChange={handleInputChange}
                        required
                        maxLength={80}
                        minLength={2}
                      />
                      <label htmlFor="titleSubDescription">Subtítulo</label>
                      <p className="basePgi__comments">
                        <span>Máximo de caracteres: 80.</span>
                      </p>
                    </div>
                    <div className="form-floating">
                      <div className="mt-5">
                        <TinyMCE
                          values={editProduct?.subdescription}
                          handleInputChange={handleInputChange}
                          name={"subdescription"}
                        />
                      </div>
                      <label htmlFor="subdescription">Descripción</label>
                    </div>
                    <article className="d-flex ">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm btn-big-img"
                        onClick={() => handleModalClick("imagen_producto")}
                      >
                        Imágenes descripción (2)
                        <WidgetsOutlined />
                      </Button>
                      <p className="m-auto w-50">
                        {editProduct.imageProduct.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct.imageProduct.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>
                    </article>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Escritorio (.jpg, .png). Proporción 4:3. Ancho máximo 2048px
                      </span>
                    </p>
                    <hr className="basePgi__space-line" />
                    <h3>Descargables</h3>
                    <p className="basePgi__comments">
                      Adjunte los archivos de fichas o manuales técnicos
                    </p>
                    <div className="pgi__archivo">
                      <input
                        type="text"
                        className="form-control"
                        name="ficha-manual"
                        id="ficha-manual"
                        placeholder="Nombre de la etiqueta del archivo"
                        maxLength={90}
                        minLength={2}
                      />

                      <input
                        type="file"
                        className="form-control"
                        name="ficha-manual"
                        id="fileProduct"
                        placeholder="..."
                        onChange={handleFileProduct}
                      />
                    </div>

                    {/* <Button variant="light" className="btn-form-pgi">
                    <AddOutlined />
                  </Button> */}
                    <Table responsive className="basePgi__table-list" hover>
                      <colgroup>
                        <col span="1" className="basePgi__table-col-max" />
                        <col span="2" className="basePgi__table-col-min" />
                      </colgroup>
                      <tbody>
                        {editProduct.filename?.map((file, index) => {
                          return (
                            !file.deleted && (
                                <tr key={index}>
                                  <td className="pgi__table-position-number">
                                    <b>{file.title}</b>
                                  </td>
                                  <td>
                                    <OverlayTrigger
                                      key="1"
                                      placement="top"
                                      overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                                    >
                                      <Button
                                        className={file.state ? "" : "disabled"}
                                        onClick={() => handleFileVisibility(file.filename)}
                                      >
                                        <VisibilityOutlined />
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                  <td>
                                    {" "}
                                    <OverlayTrigger
                                      key="1"
                                      placement="top"
                                      overlay={<Tooltip id="1">Eliminar</Tooltip>}
                                    >
                                      <Button onClick={() => handleFileDeleted(file.filename)}>
                                        <DeleteForeverOutlined />
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </tr>
                            )
                          );
                        })}
                      </tbody>
                    </Table>
                  </fieldset>
                </form>
              </Tab>
              {/* *************TABS IMAGENES *************************************** */}
              <Tab eventKey="imagenes" title="Imágenes">
                <form className="basePgi__vista-edit-gral" onSubmit={handleSubmit}>
                  <div className="form-floating">
                    <div className="pgi__container-img" style={{ display: "none" }}>
                      {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                    </div>
                    {/*implementar: al editar banner cambiar x "REEMPLAZAR"*/}
                    <article className="d-flex ">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm"
                        onClick={() => handleModalClick("logotipo")}
                      >
                        Logotipo Negativo
                        <BookmarkBorderOutlined />
                      </Button>
                      <p className="m-auto w-50">
                        {editProduct.imageLogo.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct.imageLogo.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>
                    </article>
                    <article className="d-flex ">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm"
                        onClick={() => handleModalClick("logotipo-color")}
                      >
                        Logotipo Positivo
                        <BookmarkBorderOutlined />
                      </Button>
                      <p className="m-auto w-50">
                        {editProduct.imageLogoColor.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct.imageLogoColor.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>

                      {/*implementar: al editar banner cambiar x "REEMPLAZAR"*/}
                    </article>
                    <article className="d-flex ">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm"
                        onClick={() => handleModalClick("icono")}
                      >
                        Ícono
                        <AppsOutlined />
                      </Button>
                      <p className="m-auto w-50">
                        {editProduct.imageIcon.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct.imageIcon.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>

                      {/*implementar: al editar banner cambiar x "REEMPLAZAR"*/}
                    </article>
                    <article className="d-flex ">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm"
                        onClick={() => handleModalClick("imagen_producto-alpha")}
                      >
                        Imagen producto
                        <WidgetsOutlined />
                      </Button>
                      <p className="m-auto w-50">
                        {editProduct.imageProductAlpha.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct.imageProductAlpha.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>
                    </article>
                    <article className="d-flex ">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm"
                        onClick={() => handleModalClick("imagen_carousel")}
                      >
                        Producto carousel
                        <WidgetsOutlined />
                      </Button>
                      <p className="m-auto w-50">
                        {editProduct.imageCarousel.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct.imageCarousel.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>
                    </article>
                    <article className="d-flex ">
                      <Button
                        className="btn-form-pgi pgi__head-modules w-50 shadow-sm"
                        onClick={() => handleModalClick("imagen_carousel_hover")}
                      >
                        Producto carousel hover
                        <WidgetsOutlined />
                      </Button>
                      <p className="m-auto w-50">
                        {editProduct?.imageCarouselHover?.length === 0 && (
                          <h5 className="mx-3">No hay imágenes seleccionadas</h5>
                        )}
                        {editProduct?.imageCarouselHover?.map((img, index) => (
                          <h5 className="mx-3" key={index}>
                            - {img.title ? img.title : "Imagen Seleccionada"} || {img.filename}
                          </h5>
                        ))}
                      </p>
                    </article>

                    {/*implementar: al editar banner cambiar x "REEMPLAZAR"*/}
                  </div>
                </form>
                <hr className="basePgi__space-line" />
                {/*SELECCIONAR GALERíA*/}
                <form className="basePgi__vista-edit-gral" onSubmit={handleSubmit}>
                  <div className="form-floating">
                    <h3 className="basePgi__comments">Galería Fotográfica</h3>
                    <Form.Check
                      defaultChecked={editProduct.galleryEnabled}
                      type="switch"
                      id="pgigalerySwitch"
                      label="Habilitar Galería"
                      className="pgi__switchCheck"
                      name="galleryEnabled"
                      onChange={handleInputChange}
                    />
                    <div className="pgi__container-img" style={{ display: "none" }}>
                      {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                    </div>
                    {/* MODAL GALERIA */}
                    <Modal
                      id="galleryModal"
                      className="modalContenedor__galeria"
                      show={showGaleria}
                      objectId={objectId}
                      onHide={handleCloseGaleria}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <GaleriaPgiModal
                          editProduct={editProduct}
                          setEditProduct={setEditProduct}
                          modalFor={modalFor}
                          stepId={objectId}
                          handleCloseGaleria={handleCloseGaleria}
                        />
                      </Modal.Body>
                    </Modal>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm"
                      onClick={() => handleModalClick("album")}
                    >
                      Seleccionar Álbum
                      <WallpaperOutlined />
                    </Button>
                    {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                  </div>
                </form>
                <hr className="basePgi__space-line" />
              </Tab>
              {/* *************TABS FAQs *************************************** */}

              <Tab eventKey="faqs" title="Faqs">
                <Form className="basePgi__vista-edit-gral">
                  <Form.Check
                    defaultChecked={editProduct.faqsEnabled}
                    type="switch"
                    id="pgiFaqsSwitch"
                    label="Habilitar Faqs"
                    className="pgi__switchCheck"
                    name="faqsEnabled"
                    onChange={handleInputChange}
                  />

                  <fieldset className="pgi__sidebar-container-items">
                    <h3>Preguntas y respuestas</h3>
                    <p className="basePgi__comments">
                      Desde aquí podrá cargar las preguntas y respuestas referidas a cada producto
                    </p>
                    <div className="pgi__archivo pgi__install">
                      {editProduct.faqs.map((faq, index) => {
                        return (
                          <div key={faq._id}>
                            <div className="input-group">
                              <label htmlFor="question">{index + 1}</label>
                              <input
                                type="text"
                                className="form-control"
                                name={`question`}
                                placeholder="Titulo"
                                id={faq._id}
                                defaultValue={faq.question}
                                onChange={handleFaqsInput}
                                required
                                maxLength={90}
                                minLength={2}
                              />
                              <OverlayTrigger
                                key="1"
                                placement="top"
                                overlay={<Tooltip id="1">Eliminar</Tooltip>}
                              >
                                <Button onClick={() => handleDeleteFaqs(index)}>
                                  <DeleteForeverOutlined />
                                </Button>
                              </OverlayTrigger>
                            </div>
                            <TinyMCE
                              id={faq._id}
                              values={faq.answer}
                              handleInputChange={handleFaqsInput}
                              name={"answer"}
                            />
                            <input
                              type="text"
                              className="form-control py-2"
                              name={`video`}
                              placeholder="Enlace video"
                              id={faq._id}
                              value={faq.video}
                              onChange={handleFaqsInput}
                              maxLength={100}
                            />
                          </div>
                        );
                      })}
                    </div>
                    <OverlayTrigger
                      key="1"
                      placement="top"
                      overlay={<Tooltip id="1">Nueva pregunta</Tooltip>}
                    >
                      <Button variant="light" className="btn-form-pgi allW" onClick={handleAddFaqs}>
                        <AddOutlined />
                      </Button>
                    </OverlayTrigger>
                  </fieldset>
                </Form>
                <hr className="basePgi__space-line" />
              </Tab>
              {/* *************TABS INSTALACIÓN *************************************** */}

              <Tab eventKey="instalacion" title="Instalación">
                <Form className="basePgi__vista-edit-gral">
                  <Form.Check
                    defaultChecked={editProduct.instalationStepsEnabled}
                    type="switch"
                    id="pgiInstallSwitch"
                    label="Habilitar Instalación"
                    className="pgi__switchCheck"
                    name="instalacionEnabled"
                    onChange={handleInputChange}
                  />

                  <fieldset className="pgi__sidebar-container-items">
                    <h3>Pasos</h3>
                    <p className="basePgi__comments">
                      Desde aquí podrá cargar los pasos de la instalación de un producto
                    </p>
                    <div className="pgi__archivo pgi__install">
                      {editProduct.instalationSteps.map((step, index) => {
                        return (
                          <div key={step._id}>
                            <div className="input-group">
                              <label htmlFor="stepTitle">{index + 1}</label>
                              <input
                                type="text"
                                className="form-control"
                                name={`stepTitle`}
                                placeholder="Paso"
                                id={step._id}
                                defaultValue={step.stepTitle}
                                onChange={handleStepInput}
                                maxLength={90}
                                minLength={2}
                              />
                              <OverlayTrigger
                                key="1"
                                placement="top"
                                overlay={<Tooltip id="1">Eliminar</Tooltip>}
                              >
                                <Button onClick={() => handleDeleteStep(index)}>
                                  <DeleteForeverOutlined />
                                </Button>
                              </OverlayTrigger>
                            </div>

                            <TinyMCE
                              id={step._id}
                              values={step.stepDescription}
                              handleInputChange={handleStepInput}
                              name={`stepDescription`}
                            />
                            <input
                              type="text"
                              className="form-control py-2"
                              name={`stepWarningText`}
                              placeholder="Texto de Advertencia"
                              id={step._id}
                              value={step.stepWarningText}
                              onChange={handleStepInput}
                              maxLength={284}
                              minLength={2}
                            />
                            <Button
                              className="btn-form-pgi pgi__head-modules mb-5"
                              onClick={() => handleModalClick("instalationSteps", step._id)}
                            >
                              Seleccionar imagen
                              <WallpaperOutlined />
                            </Button>
                          </div>
                        );
                      })}
                    </div>
                    <OverlayTrigger
                      key="1"
                      placement="top"
                      overlay={<Tooltip id="1">Nuevo paso</Tooltip>}
                    >
                      <Button variant="light" className="btn-form-pgi allW" onClick={handleAddStep}>
                        <AddOutlined />
                      </Button>
                    </OverlayTrigger>
                  </fieldset>
                </Form>
                <hr className="basePgi__space-line" />
              </Tab>
              {/* *************TABS MODULOS *************************************** */}

              <Tab eventKey="Módulos" title="Módulos">
                <form id="formEditarHModulos" className="basePgi__vista-edit-gral">
                  <header aria-labelledby="formEditarHModulos">
                    <h2>Módulos</h2>
                  </header>
                  <Table responsive className="basePgi__table-list" hover>
                    <colgroup>
                      <col span="1" className="basePgi__table-col-min" />
                      <col span="1" className="basePgi__table-col-position" />
                      <col span="1" className="basePgi__table-col-max" />
                      <col span="1" className="basePgi__table-col-min" />
                      <col span="1" className="basePgi__table-col-max" />
                      <col span="2" className="basePgi__table-col-min" />
                    </colgroup>
                    <tbody>
                      {
                        // mapeo automatico de tabla de modulos
                        modulesNew?.map((module, index) => {
                          return (
                            module?.title !== "TensoNews" && (
                                <tr key={index}>
                                  <td>
                                    <Button disabled>
                                      <DragHandleOutlined />
                                    </Button>
                                  </td>
                                  <td className="pgi__table-position-number">
                                    <b></b>
                                  </td>
                                  <td className="pgi__module-name">{module.title}</td>
                                  <td>{module.moduleType}</td>
                                  {module.title === "Banner_publicitario" ? (
                                    <td>{arrayBanner?.title ? arrayBanner?.title : ""}</td>
                                  ) : (
                                    <td>{module?.content ? module.content[index] : ""}</td>
                                  )}

                                  <td>
                                    <OverlayTrigger
                                      key="1"
                                      placement="top"
                                      overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                                    >
                                      <Button
                                        className={
                                          module.visible.find(
                                            (item) => item === `${editProduct._id}`
                                          )
                                            ? ""
                                            : "disabled"
                                        }
                                        onClick={() =>
                                          handleVisibility(module, `${editProduct._id}`)
                                        }
                                      >
                                        <VisibilityOutlined />
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                  {module.editable ? (
                                    <td>
                                      {/* <Button><ModeEditOutlined/></Button> */}
                                      {module.title === "Banner_publicitario" && (
                                        <OverlayTrigger
                                          key="1"
                                          placement="top"
                                          overlay={<Tooltip id="1">Ver banners</Tooltip>}
                                        >
                                          <Button onClick={() => setSelectBanner(!selectBanner)}>
                                            <ArrowForwardIosOutlined />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                      {module.title === "Bloque_info" && (
                                        <OverlayTrigger
                                          key="1"
                                          placement="top"
                                          overlay={<Tooltip id="1">Ver Bloques</Tooltip>}
                                        >
                                          <Button onClick={() => setSelectBloque(!selectBloque)}>
                                            <ArrowForwardIosOutlined />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  ) : (
                                    <td></td>
                                  )}
                                </tr>
                            )
                          );
                        })
                      }
                    </tbody>
                  </Table>
                  <button
                    type="button"
                    className="settings_button-pleno"
                    onClick={handleModuleUpdate}
                  >
                    Modificar Módulos
                  </button>
                </form>
                <hr className="basePgi__space-line" />
              </Tab>
            </Tabs>

            {selectBanner === true && (
              <>
                <form action="" id="formEditarHModulos" className="basePgi__vista-edit-gral">
                  <header aria-labelledby="formEditarHModulos">
                    <h2>Selecciona los banners</h2>
                  </header>
                  <Table responsive className="basePgi__table-list" hover>
                    <colgroup>
                      <col span="1" className="basePgi__table-col-min" />
                      <col span="1" className="basePgi__table-col-max" />
                      <col span="2" className="basePgi__table-col-min" />
                    </colgroup>
                    <tbody>
                      {banners?.map(
                        (banner) =>
                          banner?.deleted === false && (
                            <>
                              <tr key={banner._id}>
                                <td className="pgi__table-check">
                                  <Form.Check
                                    inline
                                    aria-label="banner #id" // indicar x variable el nº id
                                    name="selectBanner"
                                    type="checkbox"
                                    id="align-left"
                                    defaultChecked={banner.section.find(
                                      (item) => item === `${editProduct._id}`
                                    )}
                                    onClick={() => {
                                      handleVisibilityBanners(banner._id, `${editProduct._id}`);
                                    }}
                                  />
                                </td>
                                <td>{banner.title}</td>
                              </tr>
                            </>
                          )
                      )}
                    </tbody>
                  </Table>
                </form>
              </>
            )}

            {selectBloque === true && (
              <>
                <form action="" id="formEditarHModulos" className="basePgi__vista-edit-gral">
                  <header aria-labelledby="formEditarHModulos">
                    <h2>Selecciona los bloques de info</h2>
                  </header>
                  <Table responsive className="basePgi__table-list" hover>
                    <colgroup>
                      <col span="1" className="basePgi__table-col-min" />
                      <col span="1" className="basePgi__table-col-max" />
                      <col span="2" className="basePgi__table-col-min" />
                    </colgroup>
                    <tbody>
                      {bloques?.map(
                        (bloque) =>
                          bloque?.deleted === false && (
                            <>
                              <tr key={bloque._id}>
                                <td className="pgi__table-check">
                                  <Form.Check
                                    inline
                                    aria-label="banner #id" // indicar x variable el nº id
                                    name="selectBanner"
                                    type="checkbox"
                                    id="align-left"
                                    defaultChecked={bloque.visible.find(
                                      (item) => item === `${editProduct._id}`
                                    )}
                                    onClick={() => {
                                      handleVisibilityBloque(bloque._id, `${editProduct._id}`);
                                    }}
                                  />
                                </td>
                                <td>{bloque.title_content}</td>
                              </tr>
                            </>
                          )
                      )}
                    </tbody>
                  </Table>
                </form>
              </>
            )}
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default SideBarProducts;
